import { Box, Grid, Stack } from "@mui/material"
import { Form, Formik } from "formik"
import { useTranslation } from 'react-i18next'

import ButtonWrapper from "../../FormUI/ButtonWrapper/ButtonWrapper"
import SubmitWrapper from "../../FormUI/SubmitWrapper/SubmitWrapper"

import TextfieldWrapper from "../../FormUI/Textfield/TextfieldWrapper"
import SearchIcon from '@mui/icons-material/Search'
import UndoIcon from '@mui/icons-material/Undo'
import SelectApiWrapper from "../../FormUI/SelectWrapper/SelectApiWrapper"

export default function Filters({
    handleOnSearch
}) {
    const { t } = useTranslation()

    const initialFormState = {
        email__contains: '',
        status: 1
    }

    return (
        <Formik
            initialValues={{
                ...initialFormState
            }}
            onSubmit={handleOnSearch}
        >
            {({ handleReset, handleSubmit }) => (<Form>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextfieldWrapper
                            name="email__contains"
                            label={t('Email')}
                            type="email"
                            size="small"
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <SelectApiWrapper
                            name="status"
                            label={t('Status')}
                            size="small"
                            options={[
                                {
                                    id: 'all',
                                    name: 'All'
                                },
                                {
                                    id: 0,
                                    name: 'Inactive'
                                },
                                {
                                    id: 1,
                                    name: 'Active'
                                },
                            ]}
                        />
                    </Grid>

                    <Box width="100%" />

                    <Grid item xs={12}>
                        <Stack direction="row" spacing={2} justifyContent="flex-end">
                            <SubmitWrapper startIcon={<SearchIcon />}>{t('Search')}</SubmitWrapper>
                            <ButtonWrapper
                                onClick={() => {
                                    handleReset()
                                    handleSubmit()
                                }}
                                variant="text"
                                startIcon={<UndoIcon />}>{t('Reset')}</ButtonWrapper>
                        </Stack>
                    </Grid>
                </Grid>
            </Form>)}
        </Formik>
    )
}
